export const domain = 'https://riskpoint-service.kisrasprint.com';
// export const domain = 'http://127.0.0.1:8000/';
